export enum SelectModeState {
    NONE = 'None',
    ALL = 'All',
    MANUAL = 'Manual',
}